import { UserNotFoundInstructorError } from '../components';

export const LOGIN_API_ERROR = {
  INSTRUCTOR_ACCOUNT_EXISTS: {
    code: '-1',
    ErrorNode: (props: { onReset: () => void }) => <UserNotFoundInstructorError {...props} />,
  },
} as const;
